import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsThisForSection() {
  const forYou = ['You have $5,000–$15,000 in liquid capital you can deploy', 'You want monthly cash flow, not 30-year appreciation plays', 'You value systems and efficiency over sweat equity', "You're tired of volatile markets eating your retirement", 'You can follow a step-by-step blueprint without hand-holding'];
  const notForYou = ["You're looking for a get-rich-quick scheme", 'You want to flip houses or do construction', "You can't commit 2 hours per week to manage your portfolio", 'You need someone to do everything for you', "You're not comfortable with a proven but unconventional strategy"];
  return <section className="w-full bg-[#111827] py-12 md:py-20 px-4 relative" data-id="element-229">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-230"></div>

      <div className="max-w-5xl mx-auto" data-id="element-231">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-2xl md:text-4xl text-[#c9a84c] text-center mb-8 md:mb-16" data-id="element-232">
          Is This For You?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-233">
          {/* Left Column - YES */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#0f1724]/50 p-5 md:p-8 rounded-xl border border-[#c9a84c]/10 h-full" data-id="element-234">
            <h3 className="text-lg md:text-2xl font-bold text-white mb-5 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-235">
              <span className="bg-[#10b981]/10 p-1.5 md:p-2 rounded-full" data-id="element-236">
                <Check className="w-5 h-5 md:w-6 md:h-6 text-[#10b981]" data-id="element-237" />
              </span>
              This IS for you if...
            </h3>
            <ul className="space-y-3 md:space-y-6" data-id="element-238">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-239">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-[#10b981] mt-0.5 md:mt-1 flex-shrink-0" data-id="element-240" />
                  <span className="text-[#f5f0e8]/90 text-sm md:text-lg" data-id="element-241">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - NO */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#0f1724]/50 p-5 md:p-8 rounded-xl border border-[#c9a84c]/10 h-full" data-id="element-242">
            <h3 className="text-lg md:text-2xl font-bold text-white mb-5 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-243">
              <span className="bg-[#ef4444]/10 p-1.5 md:p-2 rounded-full" data-id="element-244">
                <X className="w-5 h-5 md:w-6 md:h-6 text-[#ef4444]" data-id="element-245" />
              </span>
              This is NOT for you if...
            </h3>
            <ul className="space-y-3 md:space-y-6" data-id="element-246">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-247">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-[#ef4444] mt-0.5 md:mt-1 flex-shrink-0" data-id="element-248" />
                  <span className="text-[#f5f0e8]/90 text-sm md:text-lg" data-id="element-249">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}